import { HlsTag } from "./HlsTag";

const REQUIRED_FIELDS: string[] = [];

export class HlsServiceZoneRequiredTag extends HlsTag {
    constructor(time: number, content?: string) {
        super("#EXT-X-SZ-REQUIRED", time, content, REQUIRED_FIELDS);
    }
}
